import {useAsyncState} from 'common/hooks/useAsyncState';
import ApiService from 'api/ApiService';
import React from 'react';
import {useHandleApiErrorCallback} from './useHandleApiErrorCallback';

type Options = {searchParams?: Record<string, string>; onSuccess?: () => void};

export function useGetApiCallback<T>() {
   const {state, loading, error, setState, setLoading, setError} = useAsyncState<T>();

   const handleError = useHandleApiErrorCallback();

   const request = React.useCallback(
      (params: {url: string; options?: Options}) => {
         let _url = params.url;
         const searchParams = params.options?.searchParams;

         if (searchParams) {
            _url = `${_url}?${new URLSearchParams(searchParams)}`;
         }

         setLoading(true);
         setState(undefined);
         ApiService.getSecureJson(_url)
            .then((res) => {
               return res.json();
            })
            .then((data: T) => {
               setState(data);
               params.options?.onSuccess?.();
               setLoading(false);
            })
            .catch(handleError({url: _url, setError, setLoading}));
      },
      [handleError, setError, setLoading, setState]
   );
   return {request, state, loading, error};
}
